import { Template } from 'types/data'

export const templates: Template[] = [
  {
    name: 'Romantic Moment',
    theme: 'Love and Affection',
    moods: ['Tender', 'Intimate', 'Passionate'],
    description:
      'A soft ballad or a melodic love song that captures the emotions of the characters in a romantic scene.',
  },
  {
    name: 'Action Sequence',
    theme: 'Excitement and Intensity',
    moods: ['Energetic', 'Adrenaline-pumping', 'Thrilling'],
    description:
      'A dynamic, fast-paced track with strong beats and intense instrumentation, enhancing the excitement of the action.',
  },
  {
    name: 'Dramatic Reveal',
    theme: 'Surprise and Revelation',
    moods: ['Suspenseful', 'Intriguing', 'Surprising'],
    description:
      // eslint-disable-next-line quotes
      "A suspenseful composition with building tension, using strings and electronic elements to emphasize the revelation's impact.",
  },
  {
    name: 'Sad or Emotional Scene',
    theme: 'Loss and Heartache',
    moods: ['Melancholic', 'Reflective', 'Sorrowful'],
    description:
      'A heartfelt ballad or a somber instrumental piece that captures the characters feelings of sadness and longing.',
  },
  {
    name: 'Comedic Moment',
    theme: 'Humor and Playfulness',
    moods: ['Light-hearted', 'Playful', 'Cheeky'],
    description:
      'An upbeat, whimsical track with quirky instrumentation and humorous lyrics that match the comedic situation.',
  },
  {
    name: 'Tense Standoff',
    theme: 'Conflict and Suspicion',
    moods: ['Tense', 'Nervous', 'Foreboding'],
    description:
      'A tense, suspenseful piece with a gradual build-up of strings and percussion to heighten the tension between characters.',
  },
  {
    name: 'Triumphant Victory',
    theme: 'Triumph and Success',
    moods: ['Uplifting', 'Euphoric', 'Empowering'],
    description:
      'An anthemic composition with powerful melodies and orchestration that captures the characters victorious achievement.',
  },
  {
    name: 'Chase Sequence',
    theme: 'Pursuit and Escape',
    moods: ['Frantic', 'Urgent', 'Heart-pounding'],
    description:
      'A fast-paced track with rhythmic percussion and electronic elements to enhance the sense of urgency and chase.',
  },
  {
    name: 'Mystical or Fantasy Moment',
    theme: 'Magic and Wonder',
    moods: ['Enchanting', 'Mystical', 'Dreamlike'],
    description:
      'A ethereal and atmospheric piece featuring whimsical instrumentation like bells and chimes, creating a sense of wonder and magic.',
  },
  {
    name: 'Nostalgic Flashback',
    theme: 'Memory and Reflection',
    moods: ['Sentimental', 'Wistful', 'Reflective'],
    description:
      'A nostalgic tune that incorporates elements of the past and evokes a sense of longing and reflection.',
  },
]
